import "react-app-polyfill/ie11";
import "webcrypto-shim";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import AppointmentForm from "./views/Appointment/AppointmentForm";
import { Auth0Provider } from "@bg/shared/lib/auth/react-auth0-wrapper";
import { SnackbarProvider } from "notistack";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";

// This is a public DSN and can be safely use in frontend code
Sentry.init({
  dsn: "https://218429f2bb2ec877cadc3469918969c3@o4509473453899776.ingest.us.sentry.io/4509473513472000",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const onRedirectCallback = (appState: any) => {
  document.location.replace(appState.targetUrl.href);
};
const isAppointmentFormRoute =
  window.location.pathname === "/gc-appointment-form";
const Root = isAppointmentFormRoute ? (
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
  >
    <AppointmentForm />
  </SnackbarProvider>
) : (
  <Auth0Provider
    domain={window.appConfig.auth0Config.domain}
    client_id={window.appConfig.auth0Config.clientID}
    audience={window.appConfig.auth0Config.audience}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
    leeway={window.appConfig.auth0Config.leeway}
  >
    <App />
  </Auth0Provider>
);
ReactDOM.render(Root, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
